module.exports = __webpack_public_path__ + "img/Gallery_2_34.4cc17227.jpeg";